<div class="file-uploader">
  <input
    type="file"
    [accept]="selectableFileTypes"
    (change)="onFileSelected($event)"
    hidden
    id="fileInput"
    data-testid="file-upload-input"
  />
  <button
    mat-raised-button
    color="primary"
    class="project-area-upload-button"
    (click)="document.getElementById('fileInput')?.click()"
    type="button"
    [disabled]="disabled"
  >
    <mat-icon>file_upload</mat-icon>
    {{ inputLabel ?? ('file.upload.label' | translate) }}
  </button>
</div>
